import MainMenuButton from './MainMenuButton';

export default MainMenuButton;
